module.exports = __webpack_public_path__ + "img/97.5f1b1f50.jpg";